import * as React from "react";
const routingContext = React.createContext({});
function RoutingProvider(props) {
  const { children, formatters, router, isMultilingual } = props;
  const format = React.useCallback(
    (config) => {
      if (!config) return null;
      if (isMultilingual) {
        config.locale = config.locale || router.locale;
      }
      for (const format2 of formatters) {
        const path = format2(config);
        if (path) {
          return path;
        }
      }
      return null;
    },
    [formatters, router.locale, isMultilingual]
  );
  const context = React.useMemo(() => ({ format, router }), [format, router]);
  return /* @__PURE__ */ React.createElement(routingContext.Provider, { value: context }, children);
}
const useRoutingContext = () => React.useContext(routingContext);
export {
  RoutingProvider,
  routingContext,
  useRoutingContext
};
//# sourceMappingURL=RoutingContext.js.map
